module.exports = __webpack_public_path__ + "956efe81abfcfb5029647a2495f488a1.pdf";